import { render, staticRenderFns } from "./DashBoardTopCardItem.vue?vue&type=template&id=0efb82e2&scoped=true"
import script from "./DashBoardTopCardItem.vue?vue&type=script&lang=js"
export * from "./DashBoardTopCardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efb82e2",
  null
  
)

export default component.exports